import flatMap from 'lodash/flatMap';
import {
  FILTER_TYPE__ALL_OF,
  FILTER_TYPE__ANY_OF,
  FILTER_CONDITION__INCLUDE,
} from '../../../common/constants';

const flattenFilters = (filters) => {
  if (!filters || filters.length === 0) {
    return [];
  }

  return flatMap(filters, (filter) => {
    if (
      filter.type === FILTER_TYPE__ALL_OF ||
      filter.type === FILTER_TYPE__ANY_OF
    ) {
      return flattenFilters(filter.settings && filter.settings.filters);
    }
    return [filter];
  });
};

export const getSelectedProjectIds = (filters) => {
  return flattenFilters(filters)
    .filter(
      (filter) =>
        filter.settings &&
        filter.settings.id === 'projectId' &&
        filter.condition === FILTER_CONDITION__INCLUDE,
    )
    .flatMap((filter) => (filter.state && filter.state.include) || []);
};

export const hasProjectFilter = (filters) =>
  flattenFilters(filters).some(
    (filter) => filter.settings && filter.settings.id === 'projectId',
  );

export default flattenFilters;
